<template>
    <div class="v-checkbox-list">
        <div class="v-checkbox-list__heading" v-if="label.length">
            <div class="v-checkbox-list__label">
                {{ label }}
            </div>

            <div class="v-checkbox-list__action" v-if="!allChosen" @click.stop="checkAll">
                {{ $t('checkboxList.selectAll') }}
            </div>

            <div class="v-checkbox-list__action" v-if="allChosen" @click.stop="uncheckAll">
                {{ $t('checkboxList.selectNone') }}
            </div>
        </div>

        <template v-for="option in options">
            <div class="v-checkbox-list__option" v-bind:key="option.value">

                <labeled-checkbox
                        @input="emit"
                        :id="'check-' + option.value"
                        :label="option.label"
                        :val="option.value"
                        v-model="values">
                </labeled-checkbox>
            </div>
        </template>

    </div>
</template>

<script>
    import LabeledCheckbox from "./vLabeledCheckbox"

    export default {
        name: "CheckboxList",
        components: {
            LabeledCheckbox
        },
        data() {
            return {
                values: this.value
            }
        },
        props: {
            label: {type: String, default: ""},
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            options: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value() {
                this.values = this.value;
            }
        },
        computed: {

            allChosen() {
                return this.values.length == this.options.length;
            }
        },
        methods: {
            checkAll() {
                let values = [];
                for (let key in this.options) {
                    values.push(this.options[key].value)
                }
                this.$emit("input", values);

            },
            uncheckAll() {
                this.$emit("input", []);

            },
            emit() {
                this.$emit('input', this.values);
            }
        }
    }
</script>

<style lang="scss">

    //noinspection CssUnknownTarget
    @import '~@/scss/main.scss';

    .v-checkbox-list {
        text-align: left;

        &__heading {
            display: flex;
            justify-content: space-between;
            margin-bottom: 1em;
            align-items: center;
        }

        &__label{
            font-weight: 600;
        }

        &__action {
            color: $primary-color;
            cursor: pointer;

        }

        &__option {
            padding: .45em 0;
        }

    }

</style>